import * as React from 'react';
import InputElement from 'react-input-mask';

import { IDocument } from '../../infrastructure/interfaces';
import CheckBox from '../CheckBox/CheckBox';
import DocumentService from '../../services/DocumentService';

export interface ICompanyInfoEditorFormProps {
  onFieldChange(field: string, value: string | boolean): void;
  document: IDocument;
  contClassName: string;
}

export interface ICompanyInfoEditorFormState {
  phone: string;
}

export default class CompanyInfoEditorForm extends React.Component<ICompanyInfoEditorFormProps, ICompanyInfoEditorFormState> {

  constructor(props: ICompanyInfoEditorFormProps) {
    super(props);
    this.state = {
      phone: this.props.document.companyInfo.phoneNumber,
    };
  }

  render() {
    return (
      <div className={`companyInfoContainer ${this.props.contClassName ? this.props.contClassName : null}`}>
        <div className="label-container_checkBox">
          <CheckBox
            onClick={() => this.props.onFieldChange('isEnabled', !this.props.document.companyInfo.isEnabled)}
            checked={this.props.document.companyInfo.isEnabled}
            disabled={false} />
          <span className="label-settings_checkBox">
            Show company information
            </span>
        </div>
        <input
          className="companyInfoInput settingCompanyInfoInput"
          placeholder="Location or Contact Name"
          type="text"
          maxLength={20}
          value={this.props.document.companyInfo.divisionName}
          onChange={e => this.props.onFieldChange('divisionName', e.target.value)}
        />
        <InputElement
          className="companyInfoInput settingCompanyInfoInput"
          placeholder="Phone number"
          mask="999-999-9999"
          type="text"
          value={this.state.phone}
          onChange={(e: any) => this.setState({ phone: e.target.value })}
          onBlur={(e: any) => {
            const isValid = DocumentService.validatePhone(e.currentTarget);
            if (!isValid) {
              this.setState({ phone: '' });
              this.props.onFieldChange('phoneNumber', '');
            } else {
              this.props.onFieldChange('phoneNumber', this.state.phone);
            }
          }}
        />
        <input
          className="companyInfoInput settingCompanyInfoInput"
          placeholder="Email"
          type="email"
          maxLength={40}
          value={this.props.document.companyInfo.email}
          onChange={e => this.props.onFieldChange('email', e.target.value)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/CompanyInfoEditorForm.tsx